import { GcpBox, GcpTypography, GcpUserTable } from '@back-office/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useViewModel from './viewmodel';

const UserDirectory: FC = () => {
  const { t } = useTranslation();

  const { auth, users, getUserList, permissionsList, handleOnClickRemove } =
    useViewModel();

  return (
    <GcpBox>
      <GcpBox>
        <GcpTypography variant="h3">{t('invite_new_user.user')}</GcpTypography>
      </GcpBox>
      <GcpBox mt={1}>
        <GcpTypography variant="body1">
          {t('invite_new_user.user_on_board', {
            merchantName: auth.currentUser.merchantName || '',
          })}
        </GcpTypography>
      </GcpBox>
      <GcpBox mt={2}>
        <GcpUserTable
          data={users.list}
          handleOnClickRemove={handleOnClickRemove}
          isRecurringMerchant={auth.currentUser?.isRecurringMerchant}
          permissionsList={permissionsList.list}
          refresh={getUserList}
        />
      </GcpBox>
    </GcpBox>
  );
};

export default UserDirectory;
